import {createStyles, Theme} from '@material-ui/core/styles';
import {defaultFont} from '../../styles/style';

const styles = (theme: Theme) => createStyles({
  inputsRow: {
    display: 'flex',
    gap: '4px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  settings__templateSection: {
  },
  settings__switch: {
    marginLeft: '8px',
  },

  settings__connectionTest: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  connectionTest__row: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  connectionTest__resultMessage: {
    ...defaultFont,
  },
  connectionTest__response: {
    ...defaultFont,
    width: '100%',
  },
  dropdown__select_template: {
    'minWidth': '150px',
    '@media (max-width: 500px)': {
      minWidth: '100%',
    },
  },
});

export default styles;
